"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Microsoftoffice = function Microsoftoffice(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.53 4.306V19.67q0 .807-.471 1.433-.472.627-1.253.85l-6.888 1.974q-.136.037-.291.055-.155.019-.292.019-.397 0-.72-.105-.322-.106-.657-.292l-4.505-2.544q-.248-.137-.391-.366-.143-.23-.143-.515 0-.434.304-.738.304-.305.739-.305h5.832V4.964l-4.38 1.563q-.534.187-.857.658-.322.472-.322 1.03v8.079q0 .496-.248.912-.249.416-.683.651l-2.072 1.13q-.286.148-.571.148-.497 0-.844-.347-.348-.347-.348-.844V6.564q0-.62.33-1.19.328-.572.874-.882L11.07.285q.248-.136.534-.21.285-.075.57-.075.212 0 .38.031.167.031.365.093l6.888 1.899q.384.111.7.329.317.217.547.52.23.305.353.67.125.367.125.764zM19.943 19.67V4.306q0-.273-.161-.478-.162-.204-.422-.279l-3.388-.93q-.397-.112-.794-.23-.397-.118-.794-.217v19.681l4.976-1.427q.26-.074.422-.28.161-.204.161-.477Z"
  }));
};

Microsoftoffice.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Microsoftoffice.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Microsoftoffice;
exports.default = _default;